<template>
  <b-container fluid>
    <RpmClassificationIndex/>
  </b-container>
</template>

<script>
import RpmClassificationIndex from '@/components/master/rpm-classification/Index';

export default {
  name: 'RpmClassification',
  components: { RpmClassificationIndex },
};
</script>
